import type { ReactElement } from "react";
import { LayoutGrid } from "lucide-react";
import { PRODUCT_NAME } from "@playbookai/types";
import { EmptyState } from "@playbookai/ui";

/**
 * Empty state shown on the launch surfaces (the Launcher page and Home) when no
 * modules are enabled for this workspace. Kept here as the single source of the
 * copy so the two surfaces never drift. The DS `EmptyState` molecule does the
 * rendering; this host element only supplies the domain wording.
 */
export function NoModulesEmptyState(): ReactElement {
  return (
    <EmptyState
      variant="first-use"
      icon={<LayoutGrid className="w-5 h-5" />}
      title="No modules enabled"
      description={`No ${PRODUCT_NAME} modules are enabled for this workspace. Contact your admin to enable one.`}
    />
  );
}
